export default {
  table: "表",
  notEmpty: "不为空",
  moneySign: "¥",
};
